"use strict";

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

var staticMethods = require('./static-methods');

Object.keys(staticMethods).forEach(function (methodName) {
  var instaceMethodName = methodName.charAt(0).toUpperCase() + methodName.slice(1);
  exports["async".concat(instaceMethodName)] =
  /*#__PURE__*/
  _asyncToGenerator(
  /*#__PURE__*/
  regeneratorRuntime.mark(function _callee() {
    var _len,
        args,
        _key,
        _args = arguments;

    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            for (_len = _args.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
              args[_key] = _args[_key];
            }

            return _context.abrupt("return", staticMethods[methodName].apply(staticMethods, [this].concat(args)));

          case 2:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, this);
  }));
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/p-iteration/lib/instance-methods.js
// module id = 715
// module chunks = 0